import { Locale } from 'modules/i18n';

export const chainProjectItemTranslation = {
  [Locale.en]: {
    dialogTitle: 'Add chain to projects',
    selectProjects: 'Select projects for chain interaction',
    selectAll: 'Select all',
    projects: 'Project{plurals, plural, =1 {} other {s}}',
    confirm: 'Confirm',
    cancel: 'Cancel',
    defaultName: 'Default',
    networks: 'Networks',
  },
};
